import ApiProvider from 'libs/providers/api/api.provider';
import { Observable } from 'rxjs';
import { AjaxResponse } from 'rxjs/ajax';
import env from 'libs/constants/env';
import Request from '../models/request';
import RequestMapping from '../mappings/request-mapping';

export type GetRequestParams = {
  canalProcedencia: Nullable<string>;
  procedencia: string | null;
  authorization?: string;
};

export type UpdateRequestParams = {
  identificadorCliente: number;
  estado: string;
  tienePrestamoVehicular: boolean;
  entidadFinaciera: null;
  codigoLugarUso: string;
  valorLugarUso: string;
  fechaInicioCobertura: string;
  aceptaTerminosCondiciones: boolean;
  consentimientoDatosPersonales: boolean;
  consentimientoVentaAsistida: boolean;
  authorization?: string;
};
class RequestProvider {
  private static instance: RequestProvider;
  static _provider: ApiProvider = new ApiProvider();
  private _requestId = '';

  static get = (params: GetRequestParams): Observable<AjaxResponse<any>> => {
    const { authorization, ...bodyRequest } = params;
    return this._provider.post(`${env.CONTEXT_PATH}/solicitudes`, bodyRequest, {
      Authorization: authorization || '',
      'Transaccion-Id': env.DEFAULT_REQUEST_ID,
    });
  };

  static update = (params: {
    authorization: string;
    request: Request;
  }): Observable<AjaxResponse<any>> => {
    const { authorization, ...body } = params;
    const request = RequestProvider.getInstance();
    const patchRequest = new RequestMapping().patchRequest(body.request);
    return this._provider.patch(
      `${env.CONTEXT_PATH}/solicitudes/${request.getRequestId()}`,
      {
        ...patchRequest,
      },
      {
        'Transaccion-Id': request.getRequestId(),
        Authorization: authorization as string,
      },
    );
  };

  public static getInstance(): RequestProvider {
    if (!RequestProvider.instance) {
      RequestProvider.instance = new RequestProvider();
    }

    return RequestProvider.instance;
  }

  public saveRequestId = (requestId: string) => {
    this._requestId = requestId;
  };

  public getRequestId = () => {
    return this._requestId;
  };

  public getRequest = () => {
    return this;
  };
}

export default RequestProvider;
